export default __webpack_public_path__ + "static/media/article-10.34dfcd24.webp";